import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './ContactPage.css';

const { FiMail, FiPhone, FiMessageCircle, FiMapPin, FiExternalLink } = FiIcons;

const CONTACT_INFO = {
  email: 'orders@dekka.lk',
  phones: ['0752912882', '0714912882'],
  whatsapp: '+940752912882',
  whatsappLink: 'https://wa.me/940752912882',
  address: 'No. 09, T. B. Jayah Mawatha, Maradana, Colombo',
  mapLink: 'https://maps.app.goo.gl/nMzjo4VRsWAGxhGH7',
  mapEmbed: 'https://www.google.com/maps?q=No.+09,+T.+B.+Jayah+Mawatha,+Maradana,+Colombo,+Sri+Lanka&output=embed'
};

function ContactPage() {
  return (
    <div className="contact-page">
      <div className="home-container">
        <div className="contact-header">
          <h1>Get in Touch</h1>
          <p>We'd love to hear from you. Reach out through any of the channels below and our team will get back to you promptly.</p>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-card-icon">
              <SafeIcon icon={FiMail} />
            </div>
            <h2>How can you email us?</h2>
            <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <SafeIcon icon={FiPhone} />
            </div>
            <h2>Call Us</h2>
            {CONTACT_INFO.phones.map((phone) => (
              <a key={phone} href={`tel:${phone}`}>{phone}</a>
            ))}
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <SafeIcon icon={FiMessageCircle} />
            </div>
            <h2>WhatsApp</h2>
            <a href={CONTACT_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
              {CONTACT_INFO.whatsapp}
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <SafeIcon icon={FiMapPin} />
            </div>
            <h2>Visit Us</h2>
            <p>{CONTACT_INFO.address}</p>
          </div>
        </div>

        <div className="contact-map-section">
          <div className="contact-map">
            <iframe
              src={CONTACT_INFO.mapEmbed}
              title="Darshana Global Enterprises location"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
          <a
            href={CONTACT_INFO.mapLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-map-link"
          >
            <SafeIcon icon={FiExternalLink} />
            Open in Google Maps
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;